import React from 'react'

import { generateRandomID } from '@/utils/idGenerator'

import { Component, ComponentContainer, Input, Label } from './Switch.styles'

type Props = {
  align?: 'flex-start' | 'flex-end'
  label?: string
  isChecked: boolean
  toggle: () => void
  direction?: 'row' | 'column'
  disabled?: boolean
}

export const SwitchComponent: React.FC<Props> = ({ align, label, isChecked, toggle, direction, disabled }) => {
  const id = generateRandomID()

  return (
    <>
      <ComponentContainer $hasLabel={!!label} htmlFor={id} $align={align} $direction={direction} $disabled={disabled}>
        {label && <Label>{label}</Label>}
        <Component checked={isChecked} $disabled={disabled} />
      </ComponentContainer>
      <Input id={id} type="checkbox" onChange={toggle} checked={isChecked} disabled={disabled} />
    </>
  )
}
